export default __webpack_public_path__ + "static/media/Club of the Ubah Kan.9d0bd5bd.jpg";